import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF, MAIN_GROUP_ID } from '../../../Layout/tokens';
import { BLOTTER_PANELS } from './shared';

const { allocations: _allocations, ...ORDER_BOOKS_BLOTTER_PANELS } = BLOTTER_PANELS;

const createSymbolPanels = (
  symbol: string,
  options?: {
    tradesTitle?: string;
  }
): Record<string, TypedGroupviewPanelState> => ({
  [`orderBook_${symbol}`]: {
    id: `orderBook_${symbol}`,
    contentComponent: 'orderBook',
    title: `${symbol} Book`,
    minimumWidth: 240,
    params: {
      type: 'orderBook',
      symbol,
      settingsInitialOpen: false,
      marketAccounts: [],
      markets: [],
      showCumQty: true,
      closable: true,
      editable: true,
    },
  },
  [`tradesHistory_${symbol}`]: {
    id: `tradesHistory_${symbol}`,
    contentComponent: 'tradesHistory',
    title: options?.tradesTitle ?? `${symbol} Trades`,
    minimumWidth: 240,
    params: {
      type: 'tradesHistory',
      symbol,
      settingsInitialOpen: false,
      marketAccounts: [],
      markets: [],
    },
  },
});

const PANELS: Record<string, TypedGroupviewPanelState> = {
  ...createSymbolPanels('BTC-USD'),
  ...createSymbolPanels('ETH-USD'),
  ...createSymbolPanels('XRP-USD'),
  ...createSymbolPanels('SOL-USD'),
  ...createSymbolPanels('USDT-USD', {
    tradesTitle: 'USDT-USD trades',
  }),
  ...ORDER_BOOKS_BLOTTER_PANELS,
};

const GRID: SerializedDockview['grid'] = {
  root: {
    type: BRANCH,
    data: [
      {
        type: BRANCH,
        data: [
          {
            type: LEAF,
            data: {
              views: ['orderBook_BTC-USD', 'tradesHistory_BTC-USD'],
              activeView: 'orderBook_BTC-USD',
              id: '1',
            },
            size: 400,
          },
          {
            type: LEAF,
            data: {
              views: ['orderBook_ETH-USD', 'tradesHistory_ETH-USD'],
              activeView: 'orderBook_ETH-USD',
              id: '2',
            },
            size: 400,
          },
          {
            type: LEAF,
            data: {
              views: ['orderBook_XRP-USD', 'tradesHistory_XRP-USD'],
              activeView: 'orderBook_XRP-USD',
              id: MAIN_GROUP_ID,
            },
            size: 400,
          },
          {
            type: LEAF,
            data: {
              views: ['orderBook_SOL-USD', 'tradesHistory_SOL-USD'],
              activeView: 'orderBook_SOL-USD',
              id: '4',
            },
            size: 400,
          },
          {
            type: LEAF,
            data: {
              views: ['orderBook_USDT-USD', 'tradesHistory_USDT-USD'],
              activeView: 'orderBook_USDT-USD',
              id: '3',
            },
            size: 400,
          },
        ],
        size: 1000,
      },
      {
        type: LEAF,
        data: {
          views: [
            'orders',
            'trades',
            'otcDerivatives',
            'loans',
            'rfqs',
            'positions',
            'reconMismatches',
            'balances',
            'credit',
            'transfers',
            'hedgePositionStatus',
          ],
          activeView: 'orders',
          id: 'blotters',
        },
        size: 300,
      },
    ],
    size: 2300,
  },
  width: 2300,
  height: 1300,
  orientation: Orientation.VERTICAL,
};

export const ORDER_BOOKS_LAYOUT: SerializedDockview = {
  grid: GRID,
  panels: PANELS,
};
